import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { accountSelector } from '../../store/shared/accountSlice';
import { useGetAccountAlertsQuery } from './apiSlice';
import {
  clearAlertMessages,
  setAlertMessages,
} from '../../../Admin/adminLayoutSlice';
import { AlertMessage } from './models';

interface Props {
  staticMessages?: AlertMessage[];
  dynamicAlerts?: boolean;
}

export default function useAccountAlerts(
  { staticMessages, dynamicAlerts }: Props = {
    staticMessages: [],
    dynamicAlerts: false,
  },
) {
  const { currentAccountId } = useSelector(accountSelector);

  const dispatch = useDispatch();
  const {
    data: alertData,
    isLoading: isAccountAlertLoading,
    isFetching: isAccountAlertFetching,
  } = useGetAccountAlertsQuery(currentAccountId, {
    skip: !currentAccountId || !dynamicAlerts,
  });

  const alerts: AlertMessage[] = useMemo(
    () => [...(alertData ?? []), ...(staticMessages ?? [])],
    [alertData, staticMessages],
  );

  useEffect(() => {
    if (alerts) {
      dispatch(setAlertMessages(alerts));
    }
  }, [alerts]);

  return { isAccountAlertFetching, isAccountAlertLoading };
}

export function useClearAlertMessages() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearAlertMessages());
  }, []);
}
